import { Box, Typography } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import React from 'react';
import { translate } from 'react-jhipster';

interface IRegisterTitle {
  contentKey: string;
  isNew: boolean;
}

export const RegisterTitle = ({ contentKey, isNew }: IRegisterTitle) => {
  const theme = useTheme();
  const title = isNew ? `${contentKey}.create` : `${contentKey}.update`;
  const TypographyTitle = propsTypography => (
    <Typography {...propsTypography} component={'strong'} variant="h5">
      {propsTypography.children}
    </Typography>
  );
  return (
    <BoxTitleContainer width={'100%'}>
      <TypographyTitle>{translate(title)}</TypographyTitle>
    </BoxTitleContainer>
  );
};
const BoxTitleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '12px 0px 24px 0px',
  color: theme.palette.text.primary,
}));
